import { render } from "./GuestVlanNetworksTab.vue?vue&type=template&id=580164b7&scoped=true"
import script from "./GuestVlanNetworksTab.vue?vue&type=script&lang=js"
export * from "./GuestVlanNetworksTab.vue?vue&type=script&lang=js"

import "./GuestVlanNetworksTab.vue?vue&type=style&index=0&id=580164b7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580164b7"]])

export default __exports__